import { useMountTransition } from "@/app/hooks/useMountTransition";
import SearchDropdownContent from "./SearchDropdownContent";

interface SearchDropdownProps {
  onClose: () => void;
  query?: string;
  onSelect?: (term: string) => void;
  isOpen: boolean;
}

const SearchDropdown = ({
  onClose,
  query = "",
  onSelect = () => {},
  isOpen,
}: SearchDropdownProps) => {
  const { rendered, isVisible } = useMountTransition(isOpen, 180);
  if (!rendered) return null;

  return (
    <div
      // Panel genişliği input'a eşit: w-full, konteynerden (arama alanı) gelir.
      // Eskiden md:min-w-lg (32rem) + lg:min-w-xl (36rem) vardı; input bundan
      // daha darsa min-width w-full'u ezip paneli input'tan geniş yapıyordu —
      // tablette input ~440px, panel 576px oluyordu. İçerik zaten esnek
      // (PopularSearches flex-wrap, SpecialProducts Swiper, öneriler min-w-0),
      // dolayısıyla alt sınıra ihtiyaç yok.
      className="absolute top-full left-0 w-full pointer-events-none z-[999]"
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(-6px)",
        transition: "opacity 180ms ease, transform 180ms ease",
      }}
    >
      <div className="pointer-events-auto mt-2 bg-white border border-main rounded-xl shadow-xl p-3 max-h-[70vh] overflow-y-auto space-y-2">
        <SearchDropdownContent
          onClose={onClose}
          query={query}
          onSelect={onSelect}
        />
      </div>
    </div>
  );
};

export default SearchDropdown;